export const DEV_BYPASS_SUBSCRIPTION_LOCK_KEY = "devBypassSubscriptionLock";

export function isDevSubscriptionBypassEnabled(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return localStorage.getItem(DEV_BYPASS_SUBSCRIPTION_LOCK_KEY) === "true";
}
